import React from 'react';
/**
 * 対象のページが存在しない場合
 *
 * @returns JSX.Element
 */
export function NotFound(): React.JSX.Element {
  return <h1>404 Not Found</h1>;
}
